import { _createUrl, _addDefaultHeaders } from './helper.js';
import { identifyError } from './error.js';
function createPost(apiEndpointOrOrigin) {
    return async function post(path, options = {}) {
        const url = _createUrl(apiEndpointOrOrigin, path, options.search);
        const fullOptions = _addDefaultHeaders(options);
        fullOptions.method ??= 'POST';
        try {
            return await fetch(url.toString(), fullOptions);
        }
        catch (error) {
            identifyError(error, url, fullOptions);
            throw error;
        }
    };
}
export { createPost };
